import React from 'react';

import { IconProps } from '../../DefaultIcon';

export function AnadoluIcon({ className }: IconProps) {
  return (
    <svg
      width="77"
      height="77"
      viewBox="0 0 77 77"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1147_2445)">
        <path d="M77 0H0V77H77V0Z" fill="#00A6DD" />
        <path d="M0 38.5L38.5231 0V38.5H0Z" fill="#0092BA" />
        <path d="M38.5 38.5L0 77V38.5H38.5Z" fill="#0092BA" />
        <path d="M76.9769 38.5L38.5 0V38.5H76.9769Z" fill="#006580" />
        <path d="M38.5 38.5L77 77V38.5H38.5Z" fill="#006580" />
        <path d="M0 76.9769L38.5 38.5V77L0 76.9769Z" fill="#006580" />
      </g>
      <defs>
        <clipPath id="clip0_1147_2445">
          <rect width="77" height="77" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
